import React, { useState } from 'react';
import './PracticeAreasModal.css';

const PracticeAreasModal = ({ isOpen, onClose, onSelect, selectedAreas }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selected, setSelected] = useState(selectedAreas || []);

  const practiceAreas = [
    'Criminal Law',
    'Family Law',
    'Banking Case Law',
    'Business Law',
    'Civil Case Law',
    'Intellectual Property Law',
    'Commercial Case',
  ];

  const filteredAreas = practiceAreas.filter(area =>
    area.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleToggleArea = (area) => {
    setSelected(prev =>
      prev.includes(area)
        ? prev.filter(a => a !== area)
        : [...prev, area]
    );
  };

  const handleOk = () => {
    onSelect(selected.join(', '));
    onClose();
  };

  const handleCancel = () => {
    setSelected(selectedAreas || []);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Practice Areas</h2>
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="modal-search"
          />
        </div>

        <div className="modal-body">
          <div className="practice-areas-grid">
            {filteredAreas.map(area => (
              <button
                key={area}
                type="button"
                className={`practice-area-button ${selected.includes(area) ? 'active' : ''}`}
                onClick={() => handleToggleArea(area)}
              >
                {area}
              </button>
            ))}
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="modal-button cancel-button"
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button
            type="button"
            className="modal-button ok-button"
            onClick={handleOk}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default PracticeAreasModal;
